import {
    CARD_ROUTE,
    COMPOSE_ROUTE,
    READING_PANE_ROUTE,
    MAIL_RESULTS_ROUTE,
    PEOPLE_RESULTS_ROUTE,
    EVENTS_RESULTS_ROUTE,
} from 'mini-search-common/lib/utils/routeConstants';

/**
 * Returns an array of search routes required for owa-router to register them.
 * These are registered to handle refreshes on mail and people module where base router is owa-router.
 */
export const getOwaRouterRoutesForUnifiedSearch = (): string[] => {
    const defaultRoute = '/search';
    return [
        defaultRoute,

        defaultRoute.concat(MAIL_RESULTS_ROUTE),
        defaultRoute.concat(MAIL_RESULTS_ROUTE, READING_PANE_ROUTE),
        defaultRoute.concat(MAIL_RESULTS_ROUTE, READING_PANE_ROUTE, CARD_ROUTE),
        defaultRoute.concat(MAIL_RESULTS_ROUTE, READING_PANE_ROUTE, COMPOSE_ROUTE),
        defaultRoute.concat(MAIL_RESULTS_ROUTE, READING_PANE_ROUTE, COMPOSE_ROUTE, CARD_ROUTE),

        defaultRoute.concat(PEOPLE_RESULTS_ROUTE),
        defaultRoute.concat(PEOPLE_RESULTS_ROUTE, CARD_ROUTE),
        defaultRoute.concat(PEOPLE_RESULTS_ROUTE, CARD_ROUTE, COMPOSE_ROUTE),

        defaultRoute.concat(EVENTS_RESULTS_ROUTE),
    ];
};
